module.exports = __webpack_public_path__ + "static/media/logo.3e97de76.svg";